import httpClient from "../../utilities/http-client";
import { LegalEntity } from "../../models/circuito/LegacyEntity";
import { useState } from "react";
import { AddActivityTagRequestModel, LegacyMarket, Market, TagResponseModel } from "../../models/market/LegacyMarket";
import { MarketGroupedByNationsForSearchResponse } from "../../models/responses/MarketGroupedByNationsForSearchResponse";
import { getDeviceLocationInfo } from "./geolocationPosition";


export const marketsList = async () => {
	try {
		const locationInfo = await getDeviceLocationInfo();
		let url = "/activities";
		if (locationInfo) {
            url += `?info=${encodeURIComponent(locationInfo)}`;
        }
		const { data } = await httpClient.get<MarketGroupedByNationsForSearchResponse[]>(url);
		return data;
	} catch (e: any) {
		throw  e;
	}
};

export const marketsListSearch = async (search: string) => {
    try {
        debugger;
        const locationInfo = await getDeviceLocationInfo();
        
        // Build query URL
        let url = `/activities/search?query=${search}`;
        if (locationInfo) {
            url += `&info=${encodeURIComponent(locationInfo)}`;
        }

        const { data } = await httpClient.get<MarketGroupedByNationsForSearchResponse[]>(url);
        return data;
    } catch (e: any) {
        throw e;
    }
};

// TODO: Legacy - da rifare 

export const myMarketsList = async () => {
	try {
		const { data } = await httpClient.get<LegacyMarket[]>(`/activities/my`);
		return data;
	} catch (e: any) {
		throw  e;
	}
};

export const myMarket = async (marketId: string) => {
	try {
		const { data } = await httpClient.get<Market>(`/activities/my/${marketId}`);
		return data;
	} catch (e: any) {
		throw  e;
	}
};

export const mymarketDelete = async (marketId:string) => {
	try{
		const { data } = await httpClient.delete<LegacyMarket[]>(`/activities/${marketId}`);
		return data;
	}catch(e:any){
		throw e;
	}
}

export const addNewActivity = async (model:Market) => {
	try{
		const { data } = await httpClient.post<Market>(`/activities`, model);
		return data;
	}catch(e:any){
		throw e;
	}
}

export const putActivity = async (model:Market) => {
	try{
		const { data } = await httpClient.put<Market>(`/activities`, model);
		return data;
	}catch(e:any){
		throw e;
	}
}

// tags
export const myMarketTags = async (marketId: string) => {
	try {
		const { data } = await httpClient.get<TagResponseModel[]>(`/activities/tag/my/${marketId}`);
		return data;
	} catch (e: any) {
		throw  e;
	}
};

export const searchTags = async (search: string) => {
	try {
		const { data } = await httpClient.get<string[]>(`/activities/tag/${search}`);
		return data;
	} catch (e: any) {
		throw  e;
	}
};

export const addNewTag = async (model:AddActivityTagRequestModel) => {
	try{
		const { data } = await httpClient.post<TagResponseModel>(`/activities/tag/`, model);
		return data;
	}catch(e:any){
		throw e;
	}
}

export const myTagDelete = async (model:TagResponseModel) => {
	try{
		const { data } = await httpClient.delete<TagResponseModel>(`/activities/tag/`,{data:model});
		return data;
	}catch(e:any){
		throw e;
	}
}
